export enum AnalyticPreviewTypeErrorEnum {
  SUBJECT_TOO_SMALL = 'report_deleted_subject_sample_too_small',
  COMPARISON_TOO_SMALL = 'report_deleted_comparison_sample_too_small',
}
